import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { DocumentRepository } from "../domain/DocumentRepository";

export async function getFullDocumentByIdCompanyAndType(
  documentRepository: DocumentRepository,
  companyId: string,
  documentId: string,
  type: string
): Promise<VectiResult> {

  try {
    const result = await documentRepository.getDocumentFullByIdCompanyAndType(
      companyId,
      documentId,
      type);
  console.log("(getFullMovementByIdCompanyAndType ) result:" +  JSON.stringify(result));
    return new VectiResult(true, result);
  } catch (error) {
    console.log("(getFullMovementByIdCompanyAndType) error:" + error);
    return new VectiResult(false, "Error");
  }
}

